export const NBA_ALL_TIME_GREATS_DEFAULT = {
  stat: "points",
};

export const NBA_ALL_TIME_GREATS_STATS = {
  points: {
    key: "points",
    label: "Points",
    railLabel: "PTS",
    statField: "points",
  },
  rebounds: {
    key: "rebounds",
    label: "Rebounds",
    railLabel: "REB",
    statField: "rebounds",
  },
  assists: {
    key: "assists",
    label: "Assists",
    railLabel: "AST",
    statField: "assists",
  },
  steals: {
    key: "steals",
    label: "Steals",
    railLabel: "STL",
    statField: "steals",
  },
  blocks: {
    key: "blocks",
    label: "Blocks",
    railLabel: "BLK",
    statField: "blocks",
  },
  ppg: {
    key: "ppg",
    label: "Points per game",
    railLabel: "PPG",
    statField: "ppg",
    minGames: 400,
    qualifier: "Minimum 400 career games",
  },
};

export const NBA_TOP_PLAYER_CATEGORIES = ["points", "rebounds", "assists", "ppg"];

export const getNbaAllTimeGreatsStat = (statKey) =>
  NBA_ALL_TIME_GREATS_STATS[statKey] ||
  NBA_ALL_TIME_GREATS_STATS[NBA_ALL_TIME_GREATS_DEFAULT.stat];

export const buildNbaAllTimeGreatsPath = ({
  stat = NBA_ALL_TIME_GREATS_DEFAULT.stat,
  page = 1,
  pageSize = 25,
} = {}) => {
  const config = getNbaAllTimeGreatsStat(stat);
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  if (config.minGames) {
    params.set("minGames", String(config.minGames));
  }
  return `/nba/all-time-greats/${config.key}?${params.toString()}`;
};
